import requests from "../util";
const { request } = requests;

const createNewInvite = (payload) => {
  return request({
    url: "/api/v1/user/inviteUserForSource",
    method: "post",
    body: payload,
  });
};
const getAllUsers = (pageNum, pageSize) => {
  let params = { pageNum, pageSize };
  return request({
    url: "/api/v1/user/listUserForSource",
    method: "get",
    params: params,
  });
};

const updateSourceAdmin = (payload) => {
  return request({
    url: "/api/v1/user/updateSourceAdminship",
    method: "patch",
    body: payload,
  });
};
const usersApi = { createNewInvite, getAllUsers, updateSourceAdmin };
export default usersApi;
